let latestFunction = null;
let latestParams = null;
export const launchFunction = (func, params) => {
  latestParams = params;
  if (latestFunction) {
    latestFunction(params);
    latestFunction = null;
    latestParams = null;
  } else if (func) {
    func(params);
  } else {
    setTimeout(() => {
      if (latestFunction) {
        latestFunction(params);
        latestFunction = null;
        latestParams = null;
      }
    }, 2000);
  }
};
setInterval(() => {
  if (latestFunction) {
    latestFunction(latestParams);
    latestFunction = null;
  }
}, 20000);

export const setFunction = (func, params) => {
  latestFunction = func;
  latestParams = params;
};

export const crearFunction = () => {
  latestFunction = null;
  latestParams = null;
};
